import {useCallback} from 'react';
import type {CodelistRestrictor} from 'services/codelists';
import {useRestrictedCodelistsContext} from 'services/codelists';
import {useManifestationImportProps} from 'services/metadata';
import {
  getRestrictedExpressionCodelist,
  getRestrictedManifestationCodelist,
} from '../functions';

export const useExpressionAndManifestationCodelistRestrictor = (
  manifestationId: string,
  expressionId: string,
): CodelistRestrictor => {
  const importProps = useManifestationImportProps(
    manifestationId,
    expressionId,
  );
  const {getRestrictedCodelist: getOuterRestrictedCodelist} =
    useRestrictedCodelistsContext();
  return useCallback(
    codelist => {
      const outerCodelist = getOuterRestrictedCodelist(codelist);
      const expressionCodelist = getRestrictedExpressionCodelist(
        importProps,
        outerCodelist,
      );
      return getRestrictedManifestationCodelist(
        importProps,
        expressionCodelist,
      );
    },
    [getOuterRestrictedCodelist, importProps],
  );
};
